import Stack from '@mui/material/Stack';
import { forwardRef } from 'react';

const Container = forwardRef<HTMLDivElement, React.PropsWithChildren>(
  ({ children }, ref) => {
    return (
      <Stack
        gap={3}
        ref={ref}
      >
        {children}
      </Stack>
    );
  },
);

Container.displayName = 'Container';

export default Container;
